import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitInput"]

  compute(event) {
    const input = event.target
    if (input.value === '') input.value = 0

    const row = input.closest('tr')
    const sum = this.sumFor(row)
    row.querySelector('.row-sum').textContent = (sum === 100 ? sum : sum.toFixed(2)) + '%'
    row.classList.toggle('error', sum !== 100)

    const hasError = Array.from(this.element.querySelectorAll('.restriction-tbody tr'))
      .some(tr => tr.classList.contains('error'))
    if (this.hasSubmitInputTarget) this.submitInputTarget.disabled = hasError
  }

  sumFor(row) {
    return Array.from(row.querySelectorAll('.summable input'))
      .reduce((total, input) => total + parseFloat(input.value), 0)
  }
}
